(() => {
  if (window.FDNavigationUpgrade) return;
  window.FDNavigationUpgrade = true;
  document.querySelectorAll('#header-group a,.fdmenu-v2 a').forEach(a=>{if(a.textContent.trim().toLowerCase()==='clubs')a.href=(window.Shopify?.routes?.root||'/')+'collections/maillots-clubs';});
  const labels = JSON.parse(document.getElementById('fd-navigation-labels')?.textContent || '{}');
  const dialog = document.getElementById('fd-account-intro');
  let trigger;
  const accountSelectors = '[data-fd-account-intro],[data-fdtab="account"],[data-fdcc-account],[data-fdc-account],.fd-loader-cta--account,.account-button';
  function isAccountEntry(element) {
    if (!element || element.closest('#fd-account-intro')) return false;
    if (element.matches(accountSelectors)) return true;
    if (!element.matches('a[href]')) return false;
    let url;
    try { url = new URL(element.getAttribute('href'), location.href); } catch (_) { return false; }
    const sameStore = url.origin === location.origin || url.hostname === 'account.foot-drop.com' || url.hostname === window.Shopify?.shop;
    if (!sameStore) return false;
    if (url.hostname === 'account.foot-drop.com' && url.pathname === '/') return true;
    return /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:account(?:\/(?:login|register))?|pages\/(?:membre|compte|espace-membre|club)|customer_authentication\/login)\/?$/i.test(url.pathname);
  }
  function markAccountEntries(root = document) {
    const entries = [...root.querySelectorAll('a[href],button,[data-fd-account-intro]')];
    if (root.nodeType === 1) entries.unshift(root);
    entries.filter(isAccountEntry).forEach(element => {
      element.setAttribute('aria-haspopup', 'dialog');
      element.setAttribute('aria-controls', 'fd-account-intro');
    });
  }
  function labelDirectories(root = document) {
    root.querySelectorAll('[data-fdpn]').forEach(button => {
      if (document.body?.dataset.fdTemplate === 'collection' && button.matches('.fd-cta-list') && button.closest('.fdh3-head')) {
        const text = button.dataset.fdpn === 'pays' ? labels.catalogueCountries : labels.catalogueClubs;
        if (!text || button.dataset.fdCatalogueLabel) return;
        button.dataset.fdCatalogueLabel = 'true';
        button.dataset.fdCompleteLabel = 'true';
        button.hidden = false;
        button.setAttribute('aria-label', text);
        button.setAttribute('aria-haspopup', 'dialog');
        button.setAttribute('aria-controls', 'fdpn-' + button.dataset.fdpn);
        const arrow = document.createElement('span');
        arrow.className = 'fd-directory-arrow'; arrow.textContent = '→'; arrow.setAttribute('aria-hidden', 'true');
        button.replaceChildren(document.createTextNode(text), arrow);
        return;
      }
      const isHomeCta = document.body?.dataset.fdTemplate === 'index' && button.matches('.fd-cta-list') && button.closest('[data-fdp]');
      if (isHomeCta) {
        const authored = button.textContent.trim();
        button.dataset.fdCompleteLabel = 'true';
        button.setAttribute('aria-label', authored);
        button.setAttribute('aria-haspopup', 'dialog');
        button.setAttribute('aria-controls', 'fdpn-' + button.dataset.fdpn);
        return;
      }
      const text = button.dataset.fdpn === 'pays' ? labels.countries : labels.clubs;
      if (!text || button.dataset.fdCompleteLabel) return;
      button.dataset.fdCompleteLabel = 'true';
      button.setAttribute('aria-label', text);
      button.setAttribute('aria-haspopup', 'dialog');
      button.setAttribute('aria-controls', 'fdpn-' + button.dataset.fdpn);
      const name = button.querySelector('.nm');
      if (name) name.textContent = text;
      else {
        const arrow = document.createElement('span');
        arrow.className = 'fd-directory-arrow'; arrow.textContent = '↗'; arrow.setAttribute('aria-hidden', 'true');
        button.replaceChildren(document.createTextNode(text), arrow);
      }
    });
    root.querySelectorAll('.fdh3-chip--more').forEach(button => {
      const row = button.closest('.fdh3-row');
      const kind = row?.dataset.fdEntities || row?.previousElementSibling?.querySelector('[data-fdpn]')?.dataset.fdpn;
      const name = button.querySelector('.nm');
      if (name && kind) name.textContent = kind === 'pays' ? labels.countries : labels.clubs;
    });
    root.querySelectorAll('.fdgc-club--more,.fdgn-flag--more,.fdh3-chip--more').forEach(button => {
      const row = button.parentElement;
      const kind = button.matches('.fdgn-flag--more') ? 'pays' : (row.dataset.fdEntities || row.previousElementSibling?.querySelector('[data-fdpn]')?.dataset.fdpn || 'clubs');
      if (!button.classList.contains('fd-directory-first')) {
        const caption = document.createElement('span');
        caption.className = 'fd-directory-caption';
        caption.textContent = (kind === 'pays' ? labels.countries : labels.clubs) || (kind === 'pays' ? 'Voir tous les pays' : 'Voir tous les clubs');
        const icon = document.createElement('span');
        icon.className = 'fd-directory-symbol';
        icon.setAttribute('aria-hidden', 'true');
        icon.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><rect x="3" y="3" width="7" height="7" rx="2"/><rect x="14" y="3" width="7" height="7" rx="2"/><rect x="3" y="14" width="7" height="7" rx="2"/><path d="M14 17.5h7m-3-3 3 3-3 3"/></svg>';
        button.replaceChildren(icon, caption);
        button.classList.add('fd-directory-first');
        button.setAttribute('aria-label', caption.textContent);
        button.setAttribute('aria-haspopup', 'dialog');
        button.setAttribute('aria-controls', 'fdpn-' + kind);
      }
      if (row.firstElementChild !== button) row.prepend(button);
      const heading = row.previousElementSibling;
      const duplicate = heading?.querySelector('[data-fdpn]');
      if (duplicate) duplicate.hidden = true;
    });

  }
  function start() {
    labelDirectories();
    markAccountEntries();
    if (!document.querySelector('.fdtop')) {
      const top=document.createElement('button');top.type='button';top.className='fdtop';top.setAttribute('aria-label',labels.top);
      top.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5M6 11l6-6 6 6"/></svg>';
      const caption=document.createElement('span');caption.textContent=labels.top;top.append(caption);document.body.append(top);
      const sync=()=>{const show=scrollY>450;top.classList.toggle('show',show);top.tabIndex=show?0:-1;};
      top.addEventListener('click',()=>scrollTo({top:0,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'}));
      window.addEventListener('scroll',sync,{passive:true});sync();
    }
    let frame = 0;
    new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(node => { if (node.nodeType === 1) markAccountEntries(node); }));
      if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-fdpn],.fdh3-chip--more,.fdgc-club--more,.fdgn-flag--more') || node.querySelector('[data-fdpn],.fdh3-chip--more,.fdgc-club--more,.fdgn-flag--more')))) && !frame) {
        frame = requestAnimationFrame(() => { frame = 0; labelDirectories(); });
      }
    }).observe(document.body, { childList: true, subtree: true });
    if (!dialog) return;
    document.addEventListener('click', event => {
      const button = event.target.closest('a,button,[role="button"],[data-fd-account-intro]');
      if (!isAccountEntry(button)) return;
      if (event.button > 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      if (button.hasAttribute('download')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      trigger = button;
      window.FDPageLoader?.finish();
      const previousDialog = button.closest('dialog[open]');
      if (previousDialog && previousDialog !== dialog) previousDialog.close();
      document.documentElement.classList.add('fd-account-open');
      if (!dialog.open) dialog.showModal();
    }, true);
    dialog.querySelector('[data-fd-account-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('keydown', event => { if (event.key === 'Escape') event.stopPropagation(); });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('fd-account-open');
      if (trigger?.isConnected) trigger.focus({ preventScroll: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();


/* FD CART ACCESS FALLBACK — 2026-09-18 */
(()=>{
  if(window.FDCartAccessFallback)return;window.FDCartAccessFallback=true;
  document.addEventListener('click',event=>{
    const trigger=event.target?.closest?.('[data-testid="cart-drawer-trigger"],a.action__cart');
    if(!trigger)return;
    if(trigger.matches('a.action__cart'))return;
    const component=trigger.closest('cart-drawer-component');
    setTimeout(()=>{
      const dialog=component?.querySelector('dialog');
      if(dialog?.open)return;
      const moon=document.getElementById('moonbundle-cart-drawer');
      const moonOpen=moon&&moon.getClientRects().length&&getComputedStyle(moon).visibility!=='hidden';
      if(moonOpen)return;
      location.assign('/cart');
    },420);
  },true);
})();
